module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/auth/auth.component.scss
// module id = ./src/app/layout/auth/auth.component.scss
// module chunks = main